export default __webpack_public_path__ + "static/media/banner_2.259bd35d.png";